// NOTE: i18n tour key prefixes for the admin sidebar rows, in the same order as
// PLATFORM_NAV_ITEMS / ADMIN_NAV_ITEMS in admin/layout/constants/nav-items.ts.
// AdminTourProvider anchors each step by `li:nth-child(index + 1)`, so the order
// here IS the positional contract with the rendered nav — a silent reorder of
// either side points every tooltip at the wrong row. The lists stay explicit
// (rather than derived) so `t()` keeps its literal key types; the invariant is
// asserted instead by tests/common/admin-tour-keys.spec.ts.
export const SIDEBAR_MENU_KEYS = [
  "dashboard",
  "users",
  "organizations",
  "projects",
  "roles",
  "chats",
  "meetings",
  "user_sessions",
  "assistants",
  "knowledge",
  "models",
  "probes",
  "integrations",
  "automations",
] as const;

export const ADMIN_MENU_KEYS = [
  "audit_logs",
  "activity_log",
  "accounts",
  "sessions",
  "external_api_keys",
] as const;

// NOTE: Platform nav items with no tour copy, so they get no step. They must
// stay AFTER every covered item, otherwise the `li:nth-child()` indices above
// shift and each tooltip lands on the wrong row.
export const TOUR_UNCOVERED_KEYS = ["appearance", "sso_domains"] as const;
